import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <div className="footerDiv">
            All icons are courtesy of <a href="https://icons8.com/" target="_blank" rel="noopener noreferrer">icons8</a>.
        </div>
    );
}

export default Footer;